<template>
  <!-- 公共弹窗 -->
  <a-modal
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="90%"
    @ok="handleOk"
    @cancel="handleCancel"
    :footer="null"
  >
    <component
      v-bind="$attrs"
      :isChild="true"
      :is="getName"
      :isRoot="isRoot"
      :isOver="isOver"
      :isJiebao="isJiebao"
      :carryOverFlag="carryOverFlag"
      :isJb="isJb"
      :filterProject="filterProject"
      :projectId="projectId"
      :isSale="isSale"
      :isReimSale="isReimSale"
      :ids="ids"
      @selectClick="selectClick"
    />
  </a-modal>
</template>

<script>
import supplierManage from '@/views/purchase/supplier/index.vue'
export default {
  name: 'PublicDialog',
  components: {
    supplierManage
  },
  props: {
    componentName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '选择信息'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    isRoot: {
      type: Boolean,
      default: false
    },
    isOver: {
      type: Boolean,
      default: false
    },
    isJiebao: {
      type: Boolean,
      default: false
    },
    carryOverFlag: {
      type: Boolean,
      default: false
    },
    isJb: {
      type: Boolean,
      default: false
    },
    filterProject: {
      type: String,
      default: ''
    },
    projectId: { // 根据项目选择采购单时，传入项目id,用于根据项目选择采购单
      type: String,
      default: ''
    },
    isSale: { // 是否是列表选择销售机会查询进入的
      type: Boolean,
      default: false
    },
    isReimSale: { // 是否是费用报销新建选择销售机会进入的
      type: Boolean,
      default: false
    },
    ids: { // 费用报销/预支预付列表
      type: String,
      default: ''
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    },
    getName () {
      if (this.componentName) {
        return (resolve) => require([`@/views/${this.componentName}/index.vue`], resolve)
      }
      return null
    }
  },
  data () {
    return {
      chooseData: '',
      chooseData1: ''
    }
  },
  mounted () {
    // console.log(this.isProjectCarryOver, '=============[][]')
  },
  methods: {
    selectClick (data, data1) {
      this.chooseData = data
      this.chooseData1 = data1
      this.handleOk()
    },
    handleOk () {
      if (this.isRoot) {
        this.$emit('logSuccess', this.chooseData, 'projectROOT', this.chooseData1)
      } else {
        this.$emit('logSuccess', this.chooseData, this.componentName, this.chooseData1)
      }
    },
    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modelDialog/publicDialog.vue